import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Blinder from '../../../common/blinder/blinder';
import { getPromoMaterialsForCartPage } from '../../../api/materials/query-promo-materials';
import isMaterialInCart from '../../../utils/material/is-material-in-cart';
import MaterialLong from '../../../common/material/material-long/material-long';
import translation, { world } from '../../../languages';
import './recommended-promo-materials.scss';
import { BUTTON_VARIANTS } from '../../../constants/button-variants';
import Button from '../../../ui/button/button';
import makeUrl from '../../../utils/url/make-url';
import Routes from '../../../constants/routes';

type RecommendedPromoMaterialsProps = TranslationProps;

const RecommendedPromoMaterials = ({ t }: RecommendedPromoMaterialsProps) => {
    const user = useSelector((state: RootState) => state.main.user);
    const cart = useSelector((state: RootState) => state.main.cart);
    const [notProcessedRecommendedPromoMaterials, setNotProcessedRecommendedPromoMaterials] = useState<Material[]>([]);
    const [recommendedPromoMaterials, setRecommendedPromoMaterials] = useState<Material[]>([]);

    useEffect(() => {
        if (!user.loaded || !cart.loaded) {
            return;
        }

        const promoAuthorId = user?.activeReferralPromotion?.author?.id;

        if (promoAuthorId) {
            getPromoMaterialsForCartPage(promoAuthorId)
                .then((materials: Material[]) => {
                    setNotProcessedRecommendedPromoMaterials(materials);
                    setRecommendedPromoMaterials(materials.filter(material => !isMaterialInCart(material.id, cart)).splice(0, 5));
                });
        }
    }, [user.loaded, cart.loaded]);

    useEffect(() => {
        const updatedRecommendedPromoMaterials = notProcessedRecommendedPromoMaterials
            .filter(material => !isMaterialInCart(material.id, cart)).splice(0, 5);

        setRecommendedPromoMaterials(updatedRecommendedPromoMaterials);
    }, [cart.cartItems.length]);

    const handleClickPromoAuthorButton = () => {
        const author = recommendedPromoMaterials[0]?.author;

        window.location.href = makeUrl(Routes.AUTHOR_MAIN.pathByWorld(world), { id: author?.id, slug: author?.slug });
    };

    if (!user.loaded || !cart.loaded) {
        return <Blinder/>;
    }

    return recommendedPromoMaterials.length ? (
        <div className='recommended-promo-materials'>
            <h4>{t('cartPromo.promoMaterialsTitle', { authorName: recommendedPromoMaterials[0]?.author?.details?.publicName })}</h4>
            {recommendedPromoMaterials.map(promoMaterial => {
                return (
                    <MaterialLong
                        internalPath='cart_pm'
                        item={promoMaterial}
                        showAddToCart
                    />
                );
            })}
            <div className='promo-author-button'>
                <Button variant={BUTTON_VARIANTS.YELLOW} onClick={handleClickPromoAuthorButton}>
                    {t('promoActivation.popularMaterials.discoverMore')}
                </Button>
            </div>
        </div>
    ) : <></>;
};

const translate = translation('referrals-landing');

export default translate(RecommendedPromoMaterials);
